module.exports = __webpack_public_path__ + "static/developer-associate-c9612f20f129cbe1fd2a77f8933ba9a1.png";